// eslint-disable-next-line import/prefer-default-export
export const LOADER_SIZE_LIST = {
  small: 16,
  medium: 32,
  large: 48,
}
